module.exports = __webpack_public_path__ + "img/tequila_aficionado_nominee.aab08414.png";